<template>
  <div>
    <h2>Misnomers</h2>
    <loading :loading="isLoading">
      <error :error="error"/>
      <div v-if="page">
        <div v-if="page.Misnomers.length === 0">You and your council have not yet flagged any notifications as misnomers.</div>
        <b-card v-if="page.Misnomers.length > 0" header="Notifications flagged as misnomers (paged in 5s)">
          <search :items="page.Misnomers" :showatonce="5">
            <template #results="data">
              <b-table striped :items="data.items" :fields="['created_at', 'author', 'notes', 'id']">
                <template #head(id)>Actions</template>
                <template #cell(id)="data">
                  <b-button-group>
                    <b-button :to="`/alerts/${data.item.topic}/${data.item.key}`" variant="primary">Notification</b-button>
                    <b-button :to="`/alerts/${data.item.topic}/${data.item.key}/misnomer`">Misnomer</b-button>
                  </b-button-group>
                </template>
                <template #cell(created_at)="data">
                  {{ data.value | moment('Do MMM YYYY HH:mm')}}
                </template>
                <template #cell(notes)="data">
                  <div style="font-weight: bold">{{ data.item.reason }}</div>
                  <blockquote v-if="data.value">&ldquo;{{ data.value}}&rdquo;</blockquote>
                </template>
              </b-table>
            </template>
          </search>
        </b-card>
      </div>
    </loading>
  </div>
</template>

<script>
import Loading from '../components/Loading.vue'
import Error from '../components/Error.vue'
import Search from '../components/Search.vue'

export default {
  components: { Loading, Error, Search },
  data() {
    return {
      isLoading: true,
      error: null,
      page: null,
    };
  },
  mounted() {
    this.isLoading = true;
    const { access_token } = this.$store.state.oidcStore;
    this.$reportingApi.renderPage('panessex', access_token, {
      pageName: 'Misnomers',
    })
    .then(page => { this.page = page; this.isLoading = false; })
    .catch(e => { this.error = e.message; this.isLoading = false; });
  },
};
</script>
